import { useCallback, useState } from 'react';
import { SimpleForm } from 'react-admin';
import { isPlainObject } from 'lodash';
import ClearIcon from '@mui/icons-material/Clear';
import Button from '@mui/material/Button';
import GooglePlacesAutocomplete from '@/components/utils/GooglePlacesAutocomplete';
import { GooglePlacesPayload } from '@/components/utils/GooglePlacesAutocomplete/types';
import { CreateStyled } from '@/styles/overrides';
import { FCRAWorker } from '@/types/turn-api';
import { HeaderContainer } from '../AddAddressForm/styled';
import { EditAddressFormProps } from './types';
import FormContent from './FormContent';

const PRELOADED_FIELDS: (keyof FCRAWorker.Address)[] = [
  'address1',
  'address2',
  'city',
  'state',
  'county',
  'zip',
  'zip4',
  'latitude',
  'longitude',
  'first_seen',
  'last_seen',
  'is_current_address',
];

const EditAddressForm = ({ address, onClose }: EditAddressFormProps) => {
  const defaultValues = PRELOADED_FIELDS.reduce(
    (acc, field) => ({ ...acc, [field]: address[field] ?? '' }),
    {} as Partial<FCRAWorker.Address>
  );

  const [pendingPlace, setPendingPlace] = useState<GooglePlacesPayload | null>(null);

  const handleGooglePlaceSelect = useCallback((data: GooglePlacesPayload) => {
    if (!isPlainObject(data)) return;
    setPendingPlace(data);
  }, []);

  return (
    <>
      <HeaderContainer>
        <Button variant="text" aria-label="Close" onClick={onClose}>
          <ClearIcon />
        </Button>
        <GooglePlacesAutocomplete onPlaceSelect={handleGooglePlaceSelect} />
      </HeaderContainer>

      <CreateStyled title="Edit Address">
        <SimpleForm
          id="candidate-addresses-edit-form"
          defaultValues={defaultValues}
          mode="onChange"
          reValidateMode="onChange"
          toolbar={false}
        >
          <FormContent address={address} onClose={onClose} pendingPlace={pendingPlace} />
        </SimpleForm>
      </CreateStyled>
    </>
  );
};

export default EditAddressForm;
